import * as React from 'react';
import { TwitterPicker } from 'react-color';
import {
    OptionBoxWrapper,
    OptionGroupElement
} from '../../../../common/optionBox';
import Toggle from '../../../../common/Toggle';
import { languageMapping } from '@nexxt/common/constants';

const OptionCardHighlight = (props) => {
    const [showColorPallete, setShowColorPallete] = React.useState(false);

    let optionTextsObject = {};
    const { option, optionError, index } = props;
    (option.texts || []).forEach((text, index) => {
        optionTextsObject[text.language] = { ...text, index };
    });
    const languages = props.languages || props.currentProject.languages || [];
    const color = props.option.color || '#FFFFFF';
    return (
        <React.Fragment>
            <div className="option-box--highlighter-box">
                <div className="row">
                    <div style={{ display: 'relative' }}>
                        <button
                            className="highlighter-box-button"
                            onClick={() =>
                                setShowColorPallete(!showColorPallete)
                            }
                            disabled={!props.editEnabled}
                        >
                            <div
                                className="option-box--highlighter-box--color"
                                style={{ backgroundColor: color }}
                            ></div>
                            <i className="nx nx-arrow-d"></i>
                        </button>
                        {showColorPallete && (
                            <div className="option-box--highlighter-box--color-picker">
                                <TwitterPicker
                                    color={color}
                                    onChangeComplete={(color) =>
                                        props.handleChangeWithValue(
                                            index,
                                            'color',
                                            color.hex
                                        )
                                    }
                                />
                            </div>
                        )}
                    </div>
                    <input
                        className="option-box--highlighter-box--color-label"
                        type="text"
                        placeholder="#000000"
                        value={color}
                        disabled={true}
                    />
                </div>
            </div>
            <OptionBoxWrapper>
                {optionError.mediaURL ? (
                    <OptionGroupElement label="" error={optionError.mediaURL}>
                        <span />
                    </OptionGroupElement>
                ) : null}
                <OptionGroupElement
                    label="highlighter label"
                    error={optionError.label}
                >
                    <input
                        type="text"
                        placeholder={`Highlighter label ${index + 1}`}
                        value={option.label}
                        onChange={(event) => props.handleChange(index, event)}
                        className="form-group__control"
                        name="label"
                        disabled={!props.editEnabled}
                        required
                    />
                </OptionGroupElement>
                {languages.map((language, textIndex) => {
                    const text = optionTextsObject[language.value] || {
                        language: language.value,
                        text: '',
                        index: -1
                    };
                    const languageError = (optionError.texts || {})[
                        text.language
                    ];
                    if (!props.isRichText) {
                        if (typeof text.text !== 'string') {
                            text.text = '';
                        }
                    }

                    return (
                        <OptionGroupElement
                            key={textIndex}
                            label={
                                <span>
                                    Highlighter text{' '}
                                    <i>({languageMapping[text.language]})</i>
                                </span>
                            }
                            error={languageError}
                        >
                            <input
                                type="text"
                                value={text.text}
                                onChange={(event) =>
                                    props.handleLanguageChange(
                                        index,
                                        text.index,
                                        event,
                                        text.language
                                    )
                                }
                                className="form-group__control"
                                disabled={!props.editEnabled}
                                required
                            />
                        </OptionGroupElement>
                    );
                })}

                <OptionGroupElement
                    label="Highlighter value"
                    error={optionError.value}
                >
                    <input
                        type="number"
                        placeholder={`${index + 1}`}
                        value={option.value}
                        onChange={(event) => props.handleChange(index, event)}
                        className="form-group__control"
                        name="value"
                        disabled={!props.editEnabled}
                        required
                        min="0"
                    />
                </OptionGroupElement>
                {props.showRandomize ? (
                    <OptionGroupElement label="Randomize">
                        <Toggle
                            onChange={(value) =>
                                props.handleToggleValueChange(
                                    index,
                                    'randomizeOption',
                                    value
                                )
                            }
                            disabled={!props.editEnabled}
                            checked={option.randomizeOption}
                        />
                    </OptionGroupElement>
                ) : null}
            </OptionBoxWrapper>
        </React.Fragment>
    );
};

export default OptionCardHighlight;
